import { driver } from "driver.js";
import { markTourSeen } from "./tourStorage";
import { filterAvailableSteps, getTourById } from "./tourSteps";

/**
 * @param {string} tourId
 * @param {{ onDestroyed?: () => void }} [options]
 */
export function createOnboardingDriver(tourId, options = {}) {
  const tour = getTourById(tourId);
  if (!tour) return null;

  const steps = filterAvailableSteps(tour.steps);
  if (!steps.length) return null;

  let dontShowAgain = true;

  const driverObj = driver({
    showProgress: true,
    animate: true,
    smoothScroll: true,
    allowClose: true,
    overlayOpacity: 0.55,
    stagePadding: 8,
    stageRadius: 10,
    popoverOffset: 12,
    popoverClass: "uc-onboarding-popover",
    showButtons: ["next", "previous", "close"],
    nextBtnText: "Next",
    prevBtnText: "Back",
    doneBtnText: "Done",
    progressText: "{{current}} of {{total}}",
    skipMissingElement: true,
    steps,
    onPopoverRender: (popover) => {
      if (popover?.closeButton) {
        popover.closeButton.innerText = "Skip tour";
      }

      const existing = popover.wrapper?.querySelector(".uc-tour-dont-show");
      if (existing) return;

      const footer = document.createElement("label");
      footer.className = "uc-tour-dont-show";
      footer.innerHTML = `
        <input type="checkbox" checked />
        <span>Don't show this again</span>
      `;
      const checkbox = footer.querySelector("input");
      checkbox?.addEventListener("change", (e) => {
        dontShowAgain = Boolean(e.target?.checked);
      });

      if (popover.footer && popover.footerButtons) {
        popover.footer.insertBefore(footer, popover.footerButtons);
      } else if (popover.wrapper) {
        popover.wrapper.appendChild(footer);
      }
    },
    onDestroyed: () => {
      if (dontShowAgain) {
        markTourSeen(tourId);
      }
      options.onDestroyed?.();
    },
  });

  return driverObj;
}

/**
 * @param {string} tourId
 * @param {{ onDestroyed?: () => void }} [options]
 */
export function startOnboardingTour(tourId, options = {}) {
  const instance = createOnboardingDriver(tourId, options);
  if (!instance) return null;
  instance.drive();
  return instance;
}
